"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yiq = void 0;
const yiq = (colorHex, options) => {
    const white = options?.light ?? '#ffffff';
    const dark = options?.dark ?? '#000000';
    const r = parseInt(colorHex.substr(1, 2), 16);
    const g = parseInt(colorHex.substr(3, 2), 16);
    const b = parseInt(colorHex.substr(5, 2), 16);
    const yiqv = (r * 299 + g * 587 + b * 114) / 1000;
    return yiqv < 128 ? white : dark;
};
exports.yiq = yiq;
